import { API_BASE_URL } from '../../../../../config';
import { FORM_CODE_FF014 } from './preEmploymentEducationTypes';
import type { PreEmploymentEducationFormValues } from './preEmploymentEducationTypes';

export const DONE_STEP_ID = '__done__';

export type PreEmploymentEducationProgressPayload = {
  values: PreEmploymentEducationFormValues;
  currentStepId: string | null;
};

export async function fetchPreEmploymentEducationProgress(
  email: string,
  invitationId: string
): Promise<PreEmploymentEducationProgressPayload | null> {
  if (!API_BASE_URL || !email?.trim() || !invitationId?.trim()) return null;
  const params = new URLSearchParams({
    email: email.trim(),
    invitationId: invitationId.trim(),
    formCode: FORM_CODE_FF014,
  });
  const r = await fetch(`${API_BASE_URL}/api/pre-employment-checklist/progress?${params.toString()}`);
  if (!r.ok) return null;
  const data = (await r.json()) as {
    educationUnderstood?: string;
    agree?: string;
    consentDateFf014?: string;
    currentStepId?: string | null;
  };
  const values: PreEmploymentEducationFormValues = {};
  if (data.educationUnderstood === 'yes' || data.educationUnderstood === 'no') {
    values.educationUnderstood = data.educationUnderstood;
  }
  if (data.agree === 'true' || data.agree === 'false') {
    values.agree = data.agree;
  }
  if (data.consentDateFf014?.trim()) {
    values.consentDateFf014 = data.consentDateFf014.trim();
  }
  return {
    values,
    currentStepId: data.currentStepId ?? null,
  };
}

export async function upsertPreEmploymentEducationProgress(params: {
  email: string;
  invitationId: string;
  values: PreEmploymentEducationFormValues;
  currentStepId: string | null;
}): Promise<PreEmploymentEducationProgressPayload | null> {
  if (!API_BASE_URL || !params.email?.trim() || !params.invitationId?.trim()) return null;
  try {
    const body: Record<string, string | null> = {
      email: params.email.trim(),
      invitationId: params.invitationId.trim(),
      formCode: FORM_CODE_FF014,
      currentStepId: params.currentStepId,
    };
    if (params.values.educationUnderstood) {
      body.educationUnderstood = params.values.educationUnderstood;
    }
    if (params.values.agree === 'true' || params.values.agree === 'false') {
      body.agree = params.values.agree;
    }
    const r = await fetch(`${API_BASE_URL}/api/pre-employment-checklist/progress`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    if (!r.ok) {
      console.warn('Pre-employment education save failed', r.status);
      return null;
    }
    const data = (await r.json()) as {
      educationUnderstood?: string;
      agree?: string;
      consentDateFf014?: string;
      currentStepId?: string | null;
    };
    const values: PreEmploymentEducationFormValues = { ...params.values };
    if (data.educationUnderstood === 'yes' || data.educationUnderstood === 'no') {
      values.educationUnderstood = data.educationUnderstood;
    }
    if (data.agree === 'true' || data.agree === 'false') {
      values.agree = data.agree;
    }
    if (data.consentDateFf014?.trim()) {
      values.consentDateFf014 = data.consentDateFf014.trim();
    } else if (params.values.agree === 'false') {
      delete values.consentDateFf014;
    }
    return {
      values,
      currentStepId: data.currentStepId ?? params.currentStepId,
    };
  } catch (e) {
    console.warn('Pre-employment education save failed', e);
    return null;
  }
}
